import React from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Navigation, Autoplay, Pagination } from 'swiper/modules'
import { strapiUrl } from '../../utils/variables'

// Import Swiper styles
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'

/**
 * ImageSlider component for displaying image carousels
 * @param {Object} props - Component props
 * @param {Object} props.data - Data containing files array
 * @returns {JSX.Element}
 */
const ImageSlider = ({ data }) => {
    if (!data || !data.files || !Array.isArray(data.files) || data.files.length === 0) {
        return null
    }

    // Strapi v5: files is a direct array, not nested in data
    const images = data.files

    return (
        <div className="blog-image-slider">
            <Swiper
                modules={[Navigation, Autoplay, Pagination]}
                navigation={images.length > 1}
                pagination={{ clickable: true }}
                loop={images.length > 1}
                autoplay={images.length > 1 ? {
                    delay: 5000,
                    disableOnInteraction: false,
                } : false}
                className="blog-swiper"
            >
                {images.map((img, index) => {
                    // Strapi v5: img is the direct object
                    const imageUrl = img.formats?.large?.url ||
                        img.formats?.medium?.url ||
                        img.url

                    return (
                        <SwiperSlide key={index}>
                            <img
                                src={imageUrl}
                                alt={img.alternativeText || `Slide ${index + 1}`}
                                className="slider-image"
                            />
                        </SwiperSlide>
                    )
                })}
            </Swiper>
        </div>
    )
}

export default ImageSlider
